// src/App.jsx
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';

// Pages
import LandingPage       from './pages/LandingPage';
import LoginPage         from './pages/LoginPage';
import Dashboard         from './pages/admin/Dashboard';
import Categories        from './pages/admin/Categories';
import Subcategories     from './pages/admin/Subcategories';
import Medicines         from './pages/admin/Medicines';
import DosageRules       from './pages/admin/DosageRules';
import Warnings          from './pages/admin/Warnings';
import Tags              from './pages/admin/Tags';
import Users             from './pages/admin/Users';
import Config            from './pages/admin/Config';
import Logs              from './pages/admin/Logs';
import DoseCalculator    from './pages/calculator/DoseCalculator';
import MedicalCalculators from './pages/calculator/MedicalCalculators';

// Global styles
import './styles/global.css';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Dose Calculator (all authenticated users) */}
          <Route path="/calculator" element={
            <ProtectedRoute><DoseCalculator /></ProtectedRoute>
          } />
          <Route path="/calculators/medical" element={
            <ProtectedRoute><MedicalCalculators /></ProtectedRoute>
          } />

          {/* Admin Panel (admin role required) */}
          <Route path="/admin" element={
            <ProtectedRoute roles={['admin', 'pharmacist', 'doctor']}><Dashboard /></ProtectedRoute>
          } />
          <Route path="/admin/categories" element={
            <ProtectedRoute roles={['admin', 'pharmacist']}><Categories /></ProtectedRoute>
          } />
          <Route path="/admin/subcategories" element={
            <ProtectedRoute roles={['admin', 'pharmacist']}><Subcategories /></ProtectedRoute>
          } />
          <Route path="/admin/medicines" element={
            <ProtectedRoute roles={['admin', 'pharmacist']}><Medicines /></ProtectedRoute>
          } />
          <Route path="/admin/dosage-rules" element={
            <ProtectedRoute roles={['admin', 'pharmacist']}><DosageRules /></ProtectedRoute>
          } />
          <Route path="/admin/warnings" element={
            <ProtectedRoute roles={['admin', 'pharmacist']}><Warnings /></ProtectedRoute>
          } />
          <Route path="/admin/tags" element={
            <ProtectedRoute roles={['admin']}><Tags /></ProtectedRoute>
          } />
          <Route path="/admin/users" element={
            <ProtectedRoute roles={['admin']}><Users /></ProtectedRoute>
          } />
          <Route path="/admin/config" element={
            <ProtectedRoute roles={['admin']}><Config /></ProtectedRoute>
          } />
          <Route path="/admin/logs" element={
            <ProtectedRoute roles={['admin']}><Logs /></ProtectedRoute>
          } />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
